module.exports = __webpack_public_path__ + "img/puzzlepieces.ddf77e1f.png";